import React from "react";
import "./Videos.css"; // Ensure you have the updated CSS
import { useLanguage } from "../LanguageContext";

// Importing video files
import video1 from "../videos/video1.mp4"; 
import video2 from "../videos/video2.mp4"; 
import video3 from "../videos/video3.mp4"; 

import alfiaPoster from "../images/alfia.png";

function Videos() {
  const { language } = useLanguage();

  return (
    <div className="videos-section">
      <h2 className="section-title videos-title">{language === 'ar' ? 'حوارات' : language === 'fr' ? 'Interviews' : 'Interviews'}</h2> {/* Big title for the section */}
      <div className="videos-container">
        <div className="video-card">
          <video
            className="video-player"
            controls
            src={video1} // Use the imported video 1
            alt="Video 1"
          />
          <div className="video-info">
            <h3 className="video-title">
              {language === 'ar' ? 'Pop-Up News على قناة 2M' : language === 'fr' ? 'Passage à Pop-Up News (2M TV)' : 'Appearance on Pop-Up News (2M TV)'}
            </h3>
            <p className="video-subtitle">
              {language === 'ar' ? 'عن إصداري الأول أضغاث أحلام' : language === 'fr' ? 'À propos de mon premier ouvrage' : 'About my first book'}
            </p>
          </div>
        </div>
        <div className="video-card">
          <video
            className="video-player"
            controls
            src={video2}
            poster={alfiaPoster}
            alt="Video 2"
          />
          <div className="video-info">
            <h3 className="video-title">
              {language === 'ar' ? 'جولة في كتاب' : language === 'fr' ? 'Une visite du livre' : 'A tour of the book'}
            </h3>
            <p className="video-subtitle">
              {language === 'ar' ? 'مع مكتبة الألفية' : language === 'fr' ? 'à la bibliothèque Alifia' : 'at Alifia Library'}
            </p>
          </div>
        </div>
        <div className="video-card">
          <video
            className="video-player"
            controls
            src={video3}
            alt="Video 3"
          />
          <div className="video-info">
            <h3 className="video-title">
              {language === 'ar' ? 'ظهور إعلامي' : language === 'fr' ? 'Apparition médiatique' : 'Media appearance'}
            </h3>
            <p className="video-subtitle">
              {language === 'ar' ? 'على قناة ميدي 1 تيفي' : language === 'fr' ? 'sur MEDI 1 TV' : 'on MEDI 1 TV'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Videos;
